import React from 'react'
import Button from '../components/Button'
import HaveProjects from '../components/HaveProjects'

const BrandingSection6 = () => {
    return (
        <div className='mt-20'>
            
        <HaveProjects />
        </div>
    )
}

export default BrandingSection6